export default __webpack_public_path__ + "bml-characteristic1.3fe3c75.png";